import { render, staticRenderFns } from "./BoolSubtractTopBarIcon.vue?vue&type=template&id=99420dba&"
import script from "./BoolSubtractTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./BoolSubtractTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports